'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IDAutoComplete = require('../autoComplete/IDAutoComplete');

var _IDAutoComplete2 = _interopRequireDefault(_IDAutoComplete);

var _IDColorPicker = require('../color/IDColorPicker');

var _IDColorPicker2 = _interopRequireDefault(_IDColorPicker);

var _IDAsyncCombobox = require('../combobox/IDAsyncCombobox');

var _IDAsyncCombobox2 = _interopRequireDefault(_IDAsyncCombobox);

var _IDDualList = require('../duallistbox/IDDualList');

var _IDDualList2 = _interopRequireDefault(_IDDualList);

var _IDIconPicker = require('../icon/IDIconPicker');

var _IDIconPicker2 = _interopRequireDefault(_IDIconPicker);

var _IDListSelect = require('../list-select/IDListSelect');

var _IDListSelect2 = _interopRequireDefault(_IDListSelect);

var _IDTag = require('../tag/IDTag');

var _IDTag2 = _interopRequireDefault(_IDTag);

var _IDTreeCombobox = require('../treecombo/IDTreeCombobox');

var _IDTreeCombobox2 = _interopRequireDefault(_IDTreeCombobox);

var _IDCombobox = require('./IDCombobox');

var _IDCombobox2 = _interopRequireDefault(_IDCombobox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = {
    combo: _IDCombobox2.default,
    tag: _IDTag2.default,
    dualList: _IDDualList2.default,
    async: _IDAsyncCombobox2.default,
    treeCombo: _IDTreeCombobox2.default,
    list: _IDListSelect2.default,
    icon: _IDIconPicker2.default,
    color: _IDColorPicker2.default,
    autoComplete: _IDAutoComplete2.default
};

var IISelect = function IISelect(props) {
    var IInput = null;
    var type = props.type;

    if (type) {
        IInput = types[type];
    }
    if (!IInput) {
        return null;
    }
    return _react2.default.createElement(IInput, (0, _extends3.default)({}, props, {
        fromCollection: true,
        ref: props.forwardRef
    }));
};

IISelect.defaultProps = {
    type: 'text'
};

var IDSelect = _react2.default.forwardRef(function (props, ref) {
    return _react2.default.createElement(IISelect, (0, _extends3.default)({}, props, { forwardRef: ref }));
});
exports.default = IDSelect;